import React, {useState} from "react";
import {useNavigate, useParams} from 'react-router-dom';
import {Button, Form, Grid, Header, Icon, List, Message, Segment} from "semantic-ui-react";
import "../../css/passReset.css";
import {getCSRFToken} from "./Auth";

const PASSWORD_RESET = process.env.REACT_APP_ICC_TOOL_API_HOST + "password-reset/";

export const PasswordResetRequest = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('')
        setMessage('')

        if (!email) {
            setError("Email is required.")
            return
        }

        setLoading(true);
        const formData = {email: email};
        try {
            const resp = await fetch(PASSWORD_RESET, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": getCSRFToken()
                },
                credentials: 'include',
                body: JSON.stringify(formData)
            })

            // A 400 from the API means the email doesn't have a corresponding user in the backend.
            if (resp.ok || resp.status === 400) {
                setMessage('Password reset instructions sent to your email.');
            } else {
                setError('Error sending password reset instructions.');
            }
        } catch (error) {
            setError('Error sending password reset instructions.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid textAlign="center" style={{height: '75vh'}} verticalAlign='middle'>
            <Grid.Column style={{maxWidth: 400}}>
                <Header as='h2' textAlign='center'>
                    Reset Password
                </Header>
                <Form size="large" onSubmit={handleSubmit} loading={loading}>
                    <Segment>
                        {error && <Message negative>{error}</Message>}
                        <Form.Input
                            fluid
                            icon="mail"
                            iconPosition="left"
                            placeholder="Email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {message && <Message info>{message}</Message>}
                        <Button className="auth-button" fluid>
                            Reset Password
                        </Button>
                    </Segment>
                </Form>
            </Grid.Column>
        </Grid>
    );
};


export const PasswordReset = () => {
    const {token} = useParams();
    let navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [passErrorList, setPassErrorList] = useState([])
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('')
        setMessage('')
        setPassErrorList([])

        if (!password) {
            setError("Password is required.")
            return
        }

        if (password !== confirmPassword) {
          setError('Passwords do not match.');
          return;
        }

        setLoading(true);
        const formData = {password: password, token: token};
        try {
            const resp = await fetch(PASSWORD_RESET + "confirm/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": getCSRFToken()
                },
                credentials: 'include',
                body: JSON.stringify(formData)
            })

            if (resp.ok) {
                setMessage('Password has been reset. Redirecting to login.');
                setTimeout(() => {
                  navigate('/login');
                }, 2000)
            } else {
                const error_resp = await resp.json();
                if ("password" in error_resp) {
                    // This will set any/all validation errors
                    setPassErrorList(error_resp["password"])
                } else {
                    setError('An error occurred resetting the password. Please try again.');
                }
            }
        } catch (error) {
            setError('An error occurred resetting the password. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid textAlign="center" style={{height: '75vh'}} verticalAlign='middle'>
            <Grid.Column style={{maxWidth: 400}}>
                <Header as='h2' textAlign='center'>
                    Reset Password
                </Header>
                <Form size="large" onSubmit={handleSubmit} loading={loading}>
                    <Segment>
                        {error && <Message negative>{error}</Message>}
                        {passErrorList.length > 0 &&
                            <Message negative>
                                <List>
                                {passErrorList.map((item) => (
                                    <List.Item>{item}</List.Item>
                                ))}
                                </List>
                            </Message>
                        }
                        <Form.Input
                            fluid
                            icon="lock"
                            iconPosition="left"
                            placeholder="Password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <Form.Input
                            fluid
                            icon="lock"
                            iconPosition="left"
                            placeholder="Confirm Password"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        {message && <Message positive><Icon name="check circle outline" /> {message}</Message>}
                        <Button className="auth-button" fluid>
                            Reset Password
                        </Button>
                    </Segment>
                </Form>
            </Grid.Column>
        </Grid>
    );
};
